export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14378.210537bc.jpg";